import React from 'react';
import Checkbox from "material-ui/Checkbox";
import PropTypes from "prop-types";
import {RadioButton, RadioButtonGroup} from "material-ui/RadioButton";
import SelectField from "material-ui/SelectField";

const IngressCheckSelectFields = (props) => {
  const {
      tapLevelValue,
      options,
      groundBlockLevelValue,
      handleOnCheck,
      value
  } = props;
  return (
      <div>
          <div className="wow-fst-signal-levels-section-field-name">
              Drop to Home
          </div>
          <div className="wow-fst-signal-levels-section-fields">
              <div className="row">
                  <div className="col s12">
                      <span>Levels at Tap</span>
                      <SelectField
                        floatingLabelText="Levels at Tap"
                        style={{width:"100%"}}
                        value={tapLevelValue}
                        onChange={(e, _, val) => handleOnCheck(e, val, `tap${value}`)}>
                          {options}
                      </SelectField>
                  </div>
              </div>
              <div className="row">
                  <div className="col s12">
                      <span>Levels at Ground Block</span>
                      <SelectField
                        floatingLabelText="Levels at Ground Block"
                        style={{width:"100%"}}
                        value={groundBlockLevelValue}
                        onChange={(e, _, val) => handleOnCheck(e, val, `groundBlock${value}`)}>
                          {options}
                      </SelectField>
                  </div>
              </div>
          </div>
      </div>
  );
};


IngressCheckSelectFields.propTypes = {
  options: PropTypes.array,
  tapLevelValue: PropTypes.bool,
  groundBlockLevelValue: PropTypes.bool,
  handleOnCheck: PropTypes.func,
  value: PropTypes.string,
};

export default IngressCheckSelectFields;



// WEBPACK FOOTER //
// ./src/components/signal-levels/IngressCheckSelectFields.js